module.exports = __webpack_public_path__ + "images/company_noimage_0ca6d71edc3f53e5f48082e42f35336e.jpg";